<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog title="Commissiepercentage" :small="true">
      <slot name="load"> </slot>
      <dean-notification :is-modal="true"> </dean-notification>
      <dean-form-row
        id="percentage"
        label="percentage"
        type="text"
        v-model="percentage"
        :warning="$v.percentage.$error"
        @focus="$v.percentage.$touch()"
        :required-field="true"
      ></dean-form-row>
      <span slot="dean-dialog-button-group">
        <dean-button
          :danger="true"
          :dialog-button="true"
          @click.native="close()"
          >Annuleren</dean-button
        >
        <dean-button
          :success="true"
          :dialog-button="true"
          @click.native="send()"
          >Versturen</dean-button
        >
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import axios from 'axios';
import {
  // SVG
  warningIcon,
  // COMPONENTS
  deanDialog,
} from '@deanone/dean-components';
import deanButton from '@/components/deanComponents/deanButton.vue';
import DeanNotification from '@/components/deanComponents/deanNotification.vue';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
import { validationMixin } from 'vuelidate';
import { required, between } from 'vuelidate/lib/validators';
import { Validations } from 'vuelidate-property-decorators';
import { createNotification } from '@/mixins/validations';
import { deanDialogBus } from '@/main';

@Component({
  components: {
    warningIcon,
    DeanNotification,
    deanDialog,
    deanButton,
    deanFormRow,
  },
  mixins: [validationMixin],
})

export default class CommissionPercentageDialog extends Vue {
  // DATA
  @Prop() public payloadData!: {
    [key: string]: string;
  };
  public percentage: string = '';
  public url: string = '';
  public urlParams: any = {};

  // COMPUTED
  @Validations()
  get validations() {
    return {
      percentage: { required, between: between(0, 100) },
    };
  }

  // METHODS
  public close() {
    deanDialogBus.$emit('close');
  }

  public send() {
    interface PercentageSaveResponseMapper {
      id: string;
      gateId: string;
      groupId: string;
      percentage: string;
      startDate: string;
      endDate: string;
    }

    const percentageSaveResponseMapper: PercentageSaveResponseMapper = {
      id: this.payloadData.id,
      gateId: this.payloadData.gateId,
      groupId: this.payloadData.groupId,
      percentage: this.percentage,
      startDate: this.payloadData.startDate,
      endDate: this.payloadData.endDate,
    };
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.$emit('setLoad', true);

      this.$store
        .dispatch(
          'processRecurringCommissionPlanGatePercentage',
          percentageSaveResponseMapper,
        )
        .then(
          (response: any) => {
            deanDialogBus.$emit('percentageChanged');
            this.close();
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
          },
        )
        .finally(() => {
          this.$emit('setLoad', false);
        });
    } else {
      this.$toast(createNotification(this.$v));
    }
  }

  public created() {
    interface PercentageInfoRequestMapper {
      id: string;
      gateId: string;
      groupId: string;
    }

    const percentageInfoRequestMapper: PercentageInfoRequestMapper = {
      id: this.payloadData.id,
      gateId: this.payloadData.gateId,
      groupId: this.payloadData.groupId,
    };

    this.urlParams = percentageInfoRequestMapper;

    if (this.payloadData.id) {
      this.$emit('setLoad', true);

      this.$store
      .dispatch(
        'requestRecurringCommissionPlanGatePercentage',
        percentageInfoRequestMapper,
      )
      .then(
        (response: any) => {
          interface PercentageInfoResponseMapper {
            id: string;
            gateId: string;
            groupId: string;
            percentage: string;
            startDate: string;
            endDate: string;
          }

          const percentageInfoResponseMapper: PercentageInfoResponseMapper = {
            id: response.data.data.id,
            gateId: response.data.data.gateId,
            groupId: response.data.data.groupId,
            percentage: response.data.data.percentage,
            startDate: response.data.data.startDate,
            endDate: response.data.data.endDate,
          };
          this.percentage = percentageInfoResponseMapper.percentage;
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      )
      .finally(() => {
        this.$emit('setLoad', false);
      });
    }
  }

  public destroyed() {
    this.$emit('setLoad', false);
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped></style>
